export default "__VITE_ASSET__1bd18b77__"